var exports = {
  "k": "xa15a2ab7--5bc5df--container",
};

module.exports = exports;
